export default [
  {
    path: "/course/:category/:id(\\d+)",
    name: "booking",
    component: (): Promise<typeof import("*.vue")> =>
      import("@/pages/web/views/Booking/Booking.vue"),
  },
];
